<div class="error-panel" [hidden]="shouldHide">    
    <p *ngIf="errorMessages[0]">
        <i class="fas fa-exclamation-triangle"></i>
        {{ errorMessages[0] }}
    </p>
</div>